// extracted by mini-css-extract-plugin
export default {"wrapper":"WGrYb","wrapper__icon":"D5set","wrapper__icon--small":"qeOcU"};